import React, { useEffect, useRef } from "react"
import useGame from "../utils/useGame"
import PropTypes from "prop-types"
import useGameClock, { formatElapsedTimeText } from "../utils/useGameClock"
import { getMessages } from "../utils/translations"

function Game(props) {
  const { bg, stop, finish, data, language } = props
  const messages = getMessages(language)
  //const [cards, reshuffle, errors, elapsedTime, finished] = useGame(bg, data); // TODO: use cardCount, BackImage and FrontImage<Array> as props
  const [cards, reshuffle, errors, finished] = useGame(bg, data) // TODO: use cardCount, BackImage and FrontImage<Array> as props
  const { elapsedTime, getElapsedTime, resetClock, stopClock } = useGameClock()
  const didFinishRef = useRef(false)

  useEffect(() => {
    if (!finished || didFinishRef.current) {
      return
    }
    didFinishRef.current = true

    const finalElapsedTime = getElapsedTime()
    stopClock()
    finish(errors, finalElapsedTime)
  }, [finished, errors, finish, getElapsedTime, stopClock])

  function startGame() {
    didFinishRef.current = false
    resetClock()
    reshuffle()
  }
  return (
    <main className={"game " + bg}>
      {/* {SnowStormSSR && <SnowStormSSR excludeMobile={false} followMouse={false} />} */}
      {/* <Header /> */}
      <nav>
        {/* <button onClick={stop}>
          Back
        </button> */}
        {/* <span className="errors">
          Fehler: <strong>{errors}</strong>
        </span> */}
        {/*
        <div id="timer" className="timer">{fancyTimeFormat(elapsedTime)}</div>
        */}
        <div id="timer">{formatElapsedTimeText(elapsedTime, language)}</div>
        <div className="right">
          <button onClick={startGame}>{messages.restart}</button>
          <button onClick={stop}>{messages.quit}</button>
          {/* <button onClick={() => finish(errors, elapsedTime)}>Win</button> */}
        </div>
      </nav>
      <div className="deck fadein">{cards}</div>
      <div id="footer"></div>
    </main>
  )
}

Game.propTypes = {
  bg: PropTypes.string.isRequired,
  stop: PropTypes.func.isRequired,
  finish: PropTypes.func.isRequired,
  language: PropTypes.string,
}

export default Game
